import {ChangeDetectionStrategy, Component, inject, output} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {OverlayRef} from '@angular/cdk/overlay';
import * as _ from 'lodash';
import {filter, map} from 'rxjs/operators';
import {PANEL_DATA} from '../../../../commons/angular/services/panel.service';
import {ServicePointsHttpService} from '../../../../service-points/angular/services/service-points-http.service';
import {ServicePointModel} from '../../../../service-points/angular/models/service-point.model';
import {getServicePointLabel} from '../../../../service-points/angular/utils/service-point-display.util';
import {
  SearchSelectFetchPage,
  TimecardSelectPanelData
} from '../timecard-search-select-list/timecard-search-select-list.component';

/** Picks one of the site's service points, for the address of a custom task. */
@Component({
  standalone: false,
  selector: 'app-timecard-service-point-select-panel',
  template: `
    <app-timecard-search-select-list [fetchPage]="fetchPage"
                                     [selectedId]="selectedId"
                                     searchLabel="Search Service Point"
                                     emptyLabel="No Service Points Found"
                                     listLabel="Service Location"
                                     (selected)="onClose.emit($event)">
    </app-timecard-search-select-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimecardServicePointSelectPanelComponent {

  // PanelService closes the panel on this output, so the name is part of its contract.
  readonly onClose = output<ServicePointModel | null>();

  private readonly servicePointsHttpService = inject(ServicePointsHttpService);

  readonly selectedId = inject<TimecardSelectPanelData>(PANEL_DATA)?.selectedId;

  readonly fetchPage: SearchSelectFetchPage<ServicePointModel> = (params) =>
    this.servicePointsHttpService.getAll(params).pipe(map((response) => ({
      cursor: response.cursor,
      list: _.map(response.list, (servicePoint) => ({
        id: servicePoint.id,
        label: servicePoint.name || getServicePointLabel(servicePoint),
        value: servicePoint
      }))
    })));

  constructor() {
    // The panel sits on top of a dialog: without this, Escape would close the dialog under it.
    inject(OverlayRef).keydownEvents().pipe(
      filter((event) => event.key === 'Escape'),
      takeUntilDestroyed()
    ).subscribe(() => this.onClose.emit(null));
  }
}
